// extracted by mini-css-extract-plugin
module.exports = {"page-gutter-s":"15px","banner1":"Banners-module__banner1___1OyAB","progress":"Banners-module__progress___BG3sy","banner2":"Banners-module__banner2___1Hx8R"};